module.exports = __webpack_public_path__ + "static/img/06.30ea7bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_frauenfeld/06.jpg
// module id = 445
// module chunks = 1